module.exports = __webpack_public_path__ + "media/banner1.ed2fe814.mp4";